(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9008],{

/***/ 28051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ CardPriorityWrapper; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62271);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(3292);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(63796);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(76131);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(66731);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/context/Cities.tsx
var Cities = __webpack_require__(54673);
// EXTERNAL MODULE: ./src/shared-styles/styles.css.ts
var styles_css = __webpack_require__(29070);
// EXTERNAL MODULE: ./src/utils/floors.tsx
var floors = __webpack_require__(21041);
// EXTERNAL MODULE: ./src/utils/getTranslatedStateOfMaintenance.ts
var getTranslatedStateOfMaintenance = __webpack_require__(77784);
// EXTERNAL MODULE: ./src/utils/navigation.ts + 1 modules
var navigation = __webpack_require__(59165);
// EXTERNAL MODULE: ./src/components/ListingCard/styles.css.ts
var ListingCard_styles_css = __webpack_require__(96845);
// EXTERNAL MODULE: ./src/components/PriorityCardBadge/index.tsx + 1 modules
var PriorityCardBadge = __webpack_require__(27638);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(89847);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/PropertyIcon/index.tsx
var PropertyIcon = __webpack_require__(7830);
// EXTERNAL MODULE: ./src/components/Translated.tsx
var Translated = __webpack_require__(36510);
// EXTERNAL MODULE: ./src/context/AuthProvider/index.ts + 2 modules
var AuthProvider = __webpack_require__(95374);
// EXTERNAL MODULE: ./src/context/Device.tsx
var Device = __webpack_require__(77808);
// EXTERNAL MODULE: ./src/design-lib/components/Badge/index.tsx + 1 modules
var Badge = __webpack_require__(53964);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./src/utils/format-listing-sellingPrice.ts
var format_listing_sellingPrice = __webpack_require__(65565);
// EXTERNAL MODULE: ./src/utils/utils-potential-properties.ts
var utils_potential_properties = __webpack_require__(43799);
// EXTERNAL MODULE: src/design-lib/style-theme/sprinkles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/sprinkles.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA6WZ227jSBJE3/srCCwW8ADtBlm8e19GN37EviwoibrYkihTlCV7MP++sKXqVkVGimxMdz/MoE4WmRUhkcr48b9gGp+2xve9v7553sfjejevzk+e8f/z7e9vP+xqCKuBs5rAqnFWc1gNndUZrEbO6gJWY2d1DauJs7qB1dRZrWE1c1abr9W2KXeHRd1sn7xdvasc4ojE139uyrb674P/h4OeEW3qtmyrhyDz59XSZQNfgXPChuo9hPMH/7v/HW4kuAjV1KfHZbl/8vz92V3P3fUoQ2DmAkmEwMIFMnGJtQvkCQIbFyiPbe0CtQsYcQ+NCwTiEkfYQdzkGbqAdePDFQwCoQuEAgAlsAcDSoj6ixCzenPc7riYZiEQoadZC0ZIajaCEaqaWjBCWNMIRmhrjoIR8pqzYITCoS/3wXsOQ9kXIom8FCoR5oIRaodSLewqlGqJXS5iTevz42FVzuvTk+d7yf78dUSe7zXLaflg8u+f/9Lv/o/Q/fCHG1Ju9ufPrntU16T687qfZ9+jvCHlwf7s9bv1W1scnjz3+RKe3VX3+RL51ys386p5nNWbunny/lUURTzJXTDk4DgZuE+dKOHgMEvcG4tyDuZ5ULjgjIGTJBsEIxdccHAymgxdcM3AfDgMhu6DPdowMA7SNHWfxFHNQD8JxyGcY0PBOAzMxAWPtJm8yAv3QR6dGTjIJsl44IAx1TpJxtHQPfCYam3iUTBw3RNTrYNJPshcrWOq9Tgp4gIuTbUukiIp3JeqmGpdfP1xQap1EX/+dUGq9ST7/OuCVOtxNI7GcDxU62E4DIdwPFTrNEzDFECqdWxiE8M7J9U6GAfjwP0oJFTrwARZ4Pox4Z9rv8gnAFKtB9E4z10/JlTrLB6NU/czk1Ctk3Tkx+5ba0K1jseDcQT3yD/XJh9E7ocroVoXRZFP3O+ehGpdFOM8g0tTrYtiNE6ga6p1UYz8yLVZSrWeJINx6N5jSrUejfJB6Hadcq3HkwlonfLv8DAfgNYp/w4v0hy0Tvl3+DBOQeuUaj2OoglonVKth6MoAa1TTWv8SkkdrZtyvj4e5DtLemQUvkSlZ0aJV7bMZ5h4+8tChrnPtMwRt633j816uWrVPrL8Po8dZbP7vOxtcb9Adrm+XwD9OvpP67att10t150louums0Q2fuyskb2fO2vc9nMfD2tTLfTW8/Aujm3nwkwOLlrOhZkcXrSbCzM5PLS6IGdzv9t1V4VomLmpo2fmpo62mZvudX5x0rY8P66qTzM8eYHv/9tlLs7Zrne3zNvKgUr/J3Raz9vVk7ferdt1uXGpECn3dsoE12O4mTJHQtxveZG+3pezdfsuLrFwV93Xn/Ki62JTff6iata7F1G/kQTsUUvCfRsrLyodD1XzeKg21awlk7DyKCHxy768aLNYbzZki6l/szo7Nk21a78eTy51EWVR79rH0y+BXSaRjEEml0yIzEwyETILycTIrCWTILORTIpMLZkMmYta9VvVLDb16fH9lw5/bqv5uvQOs6aqdl65m3sPN85Mk2x//uOr+NcM7Ot/YSLseX/fMpFgAsGkgjGCKQUTCmYumEgwS8HEgnkWTCKYrWBSwewFkwnmcGXEHBm4N8nBNBkK3mUBzpShIgjUklypiO7c1c18Gcus4O6UGakSqctsErE5YpfxJGJLxDJ60WfELkNKxLaIXT5FiO0RM/TeDogF9KJvYjfawrvolFAmENc0DIsQCykmFGV9GqEo3csKKibXCC4JSD1inglJbWK2hKROMXtCUrOYAyGpX8wbIallzDshqWvCgO3JOgoj1jsDU3ZxpmVYEpI6KGSqs85Dpjrd0Yr+W9Nw3GRLN7k/E8c99nSPjsk4bnKgm9yfj+Merr0uU3Jk3pGRz9ko+HkvdGKOeKThl7k54qmGX6bniJcafpmhIz7nuJ2kI77U8Ms8HfFnjtupOuJbjtvZOuJ7jtsJO+IHBb/O2RF/U1q9TtsRf+e4nbkDHiuesZN3xBXP2Pk74opn7BQeccUzdhaPuOIZO5FHXPGMHaIhrnjGTucRVzxjZ/SIK56xk3rEFc/YeT3iimfs1B5xxTN2dg94onjGTvARVzxj5/iIa98z12k+4opn7EwfccUzdrKPuOIZO99HXPGMnfIjrn3PXGf9iCuesRN/xBXP2Lk/4opn7PQfccUzNgPA35KKZ2wSgLjiGZsHIK555poKIK49m67ZAOLas+maECCuPZuuOQHiimdsWoC44hmbGSCue4Z96aXgGWc2iewbZ9mrafrOWfpqnAUcpm/cWcRh+VTPwCRKuoBVZVcV6zebd1XxzpddZfwMnrvKyGmAj/TsAQv3PQrpmRx6FPJjeetRyU/mvUelPJw8kAcqZ/VYFHUUsUPJiSnJxB6riCnJ0B6riClxbo8lS3p+3Wfx3F1Hj4O7sseJcFf2OBTuyq5zsY6UqQaS1oEk28BZanCDYsKBbCRZeZtlKqmY3GRZSo52U1oL3SYfyCyRka+QpfUHpiDIbRlH9tszjoyrrdokF0H0jaF0PlRajW8zEmCmgcO4SQmyVlyZlyCZMtIwsmRkyMg5IyNGLhkZM/KZkQkjt4xMGblnZMZIq7rMVz7Jrowl8D+/OSBkMdct74UssWCkczPBSNdOBSNfsCvByEHFSjDyd+yLYORL5U4w8rX2VTDyR3B7ZbpClpPk7ocsH7KgK2QxaokWssR37upOyGIFvx+yTJHiIUuFGA9ZVojxkOUFMR6y7BDjIcsrYjxkaRHjIctJ7EZb+BCdsim9EdekiUeMGA9ZhKI0GRCK0r2soJ0hy4qAPGR5ISQPWXaE5CHLKyF5yNISkocsJ0LykOWDkDxkMWxPGrLErHcGZuziNOiYEpKHLEx1GrIw1emOVvR/FLLs6Ca/F7K80j1+M2Rp6Sa/F7K49uIhywcyJGQxP++lV8gSazgPWTIN5yHLVMN5yFJxXAtZVhrOQ5YXjmshy47jWsjyynEtZGkVXAlZTkqrSsjywXEtZFE8o4Usime0kEXxjBayKJ7RQhbFM1rIonhGC1kUz2ghi+IZLWRRPKOFLIpntJBF8YwWsiie0UIWxTNayKJ4RgtZtO8ZJWRRPKOFLIpntJBF8YwWsiie0UIW7XtGCVkUz2ghi+IZLWRRPKOFLIpntJBF8YwWsiie0UIWzTNKyKI9m5SQRXs2KSGL9mxSQhbFM1rIonhGC1l0z9CQBTxzN2Q5cZaGLB+c5TN1w2E+Ro85TGIFMEnPkGXaVUUDhaqrine+6irjZ/DSVUZOA3zUP2R57VFIz6TtUciP5dSjkp/MR49KMkM38kC7g4W4o4imCsSUPSIFYsoeeQIxZVeYsKLn130WL9119Di4K3ucCHdlj0Phruw6F+vI7pDFOrBHyGJu0K6QJZYsySgySdGQZSo5HrJYC90LWVbIkFDE+qMrZNkxjuz3yjgSsli1e4QsJ4bykMVqfC9kMQ5zP2Sx4naHLBkjacgyZSQNWSpG0pBlxUgasrwwkoYsO0bSkOWVkTRksaorIcv/Adh7hk+vSAAA"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(1851);
// EXTERNAL MODULE: src/components/CardPriority/styles.css.tsx.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/CardPriority/styles.css.tsx.vanilla.css","source":"Ll82ZHVucGoxIHsKICBiYWNrZ3JvdW5kLWNvbG9yOiAjRkZGRkZGOwogIGJvcmRlcjogMXB4IHNvbGlkICNGRjk5MUY7CiAgYm9yZGVyLXJhZGl1czogY2FsYyg4cHggKyAxcHgpOwogIGJveC1zaGFkb3c6IDAgMCA2cHggMCByZ2JhKDUxLCA2OCwgODQsIDAuMjQpOwp9Ci5fNmR1bnBqMTpob3ZlciB7CiAgYm94LXNoYWRvdzogMCAwIDEwcHggMCByZ2JhKDUxLCA2OCwgODQsIDAuMjQpOwp9Ci5fNmR1bnBqNCB7CiAgYm9yZGVyLXRvcC1sZWZ0LXJhZGl1czogOHB4OwogIGJvcmRlci10b3AtcmlnaHQtcmFkaXVzOiA4cHg7CiAgb2JqZWN0LWZpdDogY292ZXI7Cn0KLl82ZHVucGo2IHsKICBiYWNrZ3JvdW5kLWNvbG9yOiAjRkZGRkZGOwogIGJvcmRlci1ib3R0b20tbGVmdC1yYWRpdXM6IDhweDsKICBib3JkZXItYm90dG9tLXJpZ2h0LXJhZGl1czogOHB4Owp9Ci5fNmR1bnBqOSB7CiAgYmFja2dyb3VuZC1jb2xvcjogI0ZGRjVFOTsKICBib3JkZXItcmFkaXVzOiA0OHB4OwogIGZvbnQtc2l6ZTogMTRweDsKfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(88068);
;// CONCATENATED MODULE: ./src/components/CardPriority/styles.css.tsx


var cardBody = '_6dunpj6 tfghjgju tfghjggc tfghjghi tfghjgio tfghjg1u tfghjg73 tfghjg7l';
var cardFooter = 'tfghjg6 tfghjg1u tfghjg7i tfghjga6 tfghjgl6';
var cardImage = '_6dunpj4 tfghjgl6';
var cardImageWrapper = 'tfghjg2c tfghjgl6';
var cardWrapper = '_6dunpj1 tfghjg1u tfghjg73 tfghjg7l tfghjga3';
var unlockPropertyMessage = '_6dunpj9 tfghjgk9 tfghjggr tfghjghr tfghjgil tfghjg6 tfghjg1u _1b5wm20bi _1b5wm206';
;// CONCATENATED MODULE: ./src/components/CardPriority/index.tsx
















var CardPriority = /*#__PURE__*/ (0,react.memo)(function(props) {
    var ref;
    var ref1 = (0,useTranslation/* default */.Z)(), lang = ref1.lang, t = ref1.t;
    var formattedPrice = (0,format_listing_sellingPrice/* formatListingSellingPrice */.F)(false, (0,utils_potential_properties/* roundPrice */._)(props.price.askedPrice), t, lang);
    var isGoodPrice = props.price.estimatedListingPrice && (0,utils_potential_properties/* getPriceStatus */.O)((ref = props.price.askedPrice) === null || ref === void 0 ? void 0 : ref.cents, props.price.estimatedListingPrice.cents).isGoodPrice;
    var showPriceStatusBadge = props.status === "priority" && isGoodPrice;
    var device = (0,Device/* useDevice */.Fy)();
    var imageHeight = device === "desktop" ? 200 : 160;
    var ref2 = (0,AuthProvider/* useAuthentication */.JL)(), isUserLoading = ref2.isLoading, user = ref2.user;
    var ref3 = config_default()(), imageBasePath = ref3.publicRuntimeConfig.imageBasePath;
    var blurredImage = !user && !isUserLoading ? "&blur=100" : "";
    var baseSrc = "".concat(props.image.src, "?auto=compress,format&h=").concat(imageHeight).concat(blurredImage);
    var srcSet = "\n  ".concat(baseSrc, "&dpr=1 1x,\n  ").concat(baseSrc, "&dpr=2 2x,\n  ").concat(baseSrc, "&dpr=3 3x\n");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cardWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cardImageWrapper,
                children: [
                    props.badge && props.badge.left,
                    !user && !isUserLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()(unlockPropertyMessage, styles_css/* absoluteCenterPositioning */.c2),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "",
                                src: "".concat(imageBasePath, "/images/priorities/priority-card-lock.svg")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                                i18Key: "priority:PriorityCard_CTA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: props.image.alt,
                        className: cardImage,
                        "data-testid": "card-main-img",
                        height: imageHeight,
                        src: "".concat(props.image.src, "?auto=compress,format&h=").concat(imageHeight).concat(blurredImage),
                        srcSet: srcSet,
                        style: {
                            height: imageHeight
                        },
                        width: "100%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cardBody,
                children: [
                    props.headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                        className: classnames_default()(styles_css/* paddingBottom.xs */.Et.xs, styles_css/* ellipsis */.LH),
                        color: "greyscale500",
                        children: props.headline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                        strong: true,
                        as: "h2",
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            marginBottom: "m",
                            marginTop: "auto"
                        }),
                        children: [
                            props.details.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    display: "flex",
                                    gap: "s"
                                }),
                                children: props.details.map(function(detail, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: detail
                                    }, index);
                                })
                            }),
                            props.info.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    display: "flex",
                                    gap: "m",
                                    marginTop: "auto"
                                }),
                                "data-testid": "priority-card-info",
                                children: props.info.map(function(info, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                                color: "greyscale500",
                                                children: info.heading
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (0,sprinkles_css/* sprinkles */.K)({
                                                    alignItems: "center",
                                                    display: "flex",
                                                    gap: "xs"
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                                        children: info.text
                                                    }),
                                                    info.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyIcon/* default */.Z, {
                                                        kind: info.icon
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    ((props === null || props === void 0 ? void 0 : props.hasOutdoorSpace) || (props === null || props === void 0 ? void 0 : props.isHighEfficiency)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            paddingBottom: "s"
                        }),
                        children: [
                            (props === null || props === void 0 ? void 0 : props.hasOutdoorSpace) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                icon: "Tree",
                                styleVariant: "greyscale"
                            }),
                            (props === null || props === void 0 ? void 0 : props.isHighEfficiency) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                icon: "Sun",
                                styleVariant: "greyscale"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: cardFooter,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                "data-testid": "priority-card-price",
                                children: formattedPrice
                            }),
                            showPriceStatusBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    marginLeft: "auto"
                                }),
                                icon: "Verified",
                                label: t("priority:PriceAnalysis_GoodPrice_Tag"),
                                solid: false,
                                styleVariant: "success"
                            })
                        ]
                    })
                ]
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/components/CardPriority/CardPriorityWrapper.tsx

















var CardPriorityWrapper = function(_param) {
    var cardData = _param.cardData, handleCardClick = _param.handleCardClick, props = (0,_object_without_properties/* default */.Z)(_param, [
        "cardData",
        "handleCardClick"
    ]);
    var ref, ref1, ref2;
    var ref3 = (0,useTranslation/* default */.Z)(), lang = ref3.lang, t = ref3.t;
    var cities = (0,Cities/* useCities */.M1)();
    var priorityCity = cities.list.find(function(city) {
        return city.slug === cardData.city;
    });
    var ref4 = (0,_sliced_to_array/* default */.Z)((((ref = cardData.zone) === null || ref === void 0 ? void 0 : ref.slug) || cardData.city).split("/"), 1), country = ref4[0];
    var locale = lang !== "en" && country;
    var listingLink = (0,navigation/* joinPaths */.RQ)(locale, "priority", cardData.slug);
    var ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        passHref: true,
        href: listingLink,
        locale: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            onClick: handleCardClick
        }, props), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPriority, {
                badge: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriorityCardBadge/* PriorityBadge */.U, {})
                },
                details: (0,_to_consumable_array/* default */.Z)(cardData.commercialArea ? [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                                as: "span",
                                "data-testid": "priority-card-area",
                                children: cardData.commercialArea
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                as: "span",
                                color: "greyscale500",
                                children: "m\xb2"
                            })
                        ]
                    }), 
                ] : []).concat([
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                                as: "span",
                                className: styles_css/* marginRight.s */.wz.s,
                                "data-testid": "priority-card-floor",
                                children: (0,floors/* propertyFloorFormatter */.vH)({
                                    buildingFloors: cardData.buildingFloors,
                                    entireBuilding: false,
                                    entranceFloor: cardData.entranceFloor,
                                    floorPosition: []
                                }, t)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                as: "span",
                                color: "greyscale500",
                                children: (0,floors/* propertyFloorSuffix */.MN)({
                                    buildingFloors: cardData.buildingFloors,
                                    entireBuilding: false,
                                    entranceFloor: cardData.entranceFloor,
                                    floorPosition: []
                                }, t)
                            })
                        ]
                    }),
                    , 
                ]),
                hasOutdoorSpace: cardData.hasOutdoorSpace,
                headline: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (priorityCity === null || priorityCity === void 0 ? void 0 : priorityCity.translatedCityName) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: priorityCity === null || priorityCity === void 0 ? void 0 : priorityCity.translatedCityName
                            }),
                            cardData.zone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: ListingCard_styles_css/* cardCityAreaDivider */.JS
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "data-testid": "listing-card-zone",
                                        children: cardData.zone.label
                                    })
                                ]
                            })
                        ]
                    })
                }),
                image: {
                    alt: "",
                    src: (ref5 = (ref1 = cardData.photos[0]) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref5 !== void 0 ? ref5 : ""
                },
                info: (0,_to_consumable_array/* default */.Z)(cardData.rooms ? [
                    {
                        heading: t("common:rooms"),
                        icon: "rooms",
                        text: cardData.rooms
                    }, 
                ] : []).concat((0,_to_consumable_array/* default */.Z)(cardData.bathrooms ? [
                    {
                        heading: t("common:bathrooms"),
                        icon: "bathroom",
                        text: cardData.bathrooms
                    }, 
                ] : []), (0,_to_consumable_array/* default */.Z)(cardData.stateOfMaintenance ? [
                    {
                        heading: t("common:status"),
                        text: (0,getTranslatedStateOfMaintenance/* getTranslatedStateOfMaintenance */.o)(cardData.stateOfMaintenance, t)
                    }, 
                ] : [])),
                isHighEfficiency: [
                    "a",
                    "aplus",
                    "b"
                ].includes((ref2 = cardData.energyRating) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()),
                price: {
                    askedPrice: cardData.price,
                    estimatedListingPrice: cardData.estimatedListingPrice
                },
                status: cardData.status,
                title: cardData.title
            })
        }))
    });
};


/***/ }),

/***/ 23777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ ItemsCarousel; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(76131);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/context/Device.tsx
var Device = __webpack_require__(77808);
// EXTERNAL MODULE: ./src/design-lib/theme.ts
var theme = __webpack_require__(56161);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 21 modules
var Icon = __webpack_require__(81016);
// EXTERNAL MODULE: src/components/ItemsCarousel/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/ItemsCarousel/styles.css.ts.vanilla.css","source":"Ll8xcTlsMzQxMCB7CiAgcG9zaXRpb246IHJlbGF0aXZlOwp9Ci5fMXE5bDM0MTEgewogIHNjcm9sbGJhci13aWR0aDogbm9uZTsKICAtd2Via2l0LW92ZXJmbG93LXNjcm9sbGluZzogdG91Y2g7CiAgZGlzcGxheTogZmxleDsKICBmbGV4LXdyYXA6IG5vd3JhcDsKICBwb3NpdGlvbjogcmVsYXRpdmU7CiAgb3ZlcmZsb3cteDogYXV0bzsKICBvdmVyZmxvdy15OiBoaWRkZW47CiAgcGFkZGluZy1ib3R0b206IDRweDsKICBwYWRkaW5nLXRvcDogNHB4OwogIHBhZGRpbmctbGVmdDogNHB4OwogIHBhZGRpbmctcmlnaHQ6IDRweDsKfQouXzFxOWwzNDExOjotd2Via2l0LXNjcm9sbGJhciB7CiAgZGlzcGxheTogbm9uZTsKfQouXzFxOWwzNDEyIHsKICBmbGV4LXNocmluazogMDsKfQouXzFxOWwzNDEzIHsKICBoZWlnaHQ6IDEwMCU7CiAgcG9zaXRpb246IGFic29sdXRlOwogIHRvcDogMDsKICB3aWR0aDogNDVweDsKfQouXzFxOWwzNDE0IHsKICBsZWZ0OiAwOwp9Ci5fMXE5bDM0MTUgewogIHJpZ2h0OiAwOwp9Ci5fMXE5bDM0MTYgewogIGFsaWduLWl0ZW1zOiBjZW50ZXI7CiAgYmFja2dyb3VuZC1jb2xvcjogI0ZGRkZGRjsKICBib3JkZXItcmFkaXVzOiA1MCU7CiAgY29sb3I6ICMxRDFEMUI7CiAgZGlzcGxheTogZmxleDsKICBoZWlnaHQ6IDQ4cHg7CiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7CiAgcGFkZGluZzogNXB4OwogIHBvc2l0aW9uOiBhYnNvbHV0ZTsKICB0b3A6IDUwJTsKICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTI0cHgpOwogIHdpZHRoOiA0OHB4OwogIGJveC1zaGFkb3c6IDAgMXB4IDRweCAwIHJnYmEoMjksMjksMjcsMC4zKTsKfQouXzFxOWwzNDE3IHsKICBsZWZ0OiAtMjRweDsKfQouXzFxOWwzNDE4IHsKICByaWdodDogLTI0cHg7Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(52236);
;// CONCATENATED MODULE: ./src/components/ItemsCarousel/styles.css.ts

var carousel = '_1q9l3410';
var controlButton = {left:'_1q9l3417 _1q9l3416',right:'_1q9l3418 _1q9l3416'};
var controlButtonBase = '_1q9l3416';
var controlContainer = {left:'_1q9l3414 _1q9l3413',right:'_1q9l3415 _1q9l3413'};
var controlContainerBase = '_1q9l3413';
var item = '_1q9l3412';
var itemsContainer = '_1q9l3411';
;// CONCATENATED MODULE: ./src/components/ItemsCarousel/ItemsCarousel.tsx








var ItemsCarousel = function(param) {
    var children = param.children, lastChild = param.lastChild, itemsGap = param.itemsGap, itemsWidth = param.itemsWidth, _onNextClicked = param.onNextClicked, onNextClicked = _onNextClicked === void 0 ? function() {} : _onNextClicked, _onPrevClicked = param.onPrevClicked, onPrevClicked = _onPrevClicked === void 0 ? function() {} : _onPrevClicked, className = param.className, hasInnerNextButton = param.hasInnerNextButton;
    var device = (0,Device/* useDevice */.Fy)();
    var ref = (0,react.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    var ref1 = (0,react.useState)(children), childrenParsed = ref1[0], setChildrenParsed = ref1[1];
    var ref2 = (0,react.useState)(null), itemsContainerRef = ref2[0], setItemsContainerRef = ref2[1];
    (0,react.useEffect)(function() {
        if (!itemsContainerRef) return;
        itemsContainerRef.scrollTo({
            behavior: "smooth",
            left: (itemsWidth + parseInt(theme/* theme.spacings */.r.spacings[itemsGap])) * currentIndex
        });
    }, [
        currentIndex
    ]);
    var shouldLeftArrowBeVisible = function() {
        return device === "desktop" && currentIndex > 0;
    };
    var shouldRightArrowBeVisible = function() {
        if (device !== "desktop") return false;
        var lastScrollableIndex = calcLastScrollableIndex();
        return lastScrollableIndex !== undefined && currentIndex < lastScrollableIndex;
    };
    var calcLastScrollableIndex = function() {
        if (!itemsContainerRef) return undefined;
        var carouselWidth = itemsContainerRef.clientWidth;
        var totalVisibleItems = Math.floor(carouselWidth / itemsWidth);
        return childrenParsed.length - totalVisibleItems;
    };
    var goToPrevious = function() {
        setCurrentIndex(currentIndex - 1);
        onPrevClicked();
    };
    var goToNext = function() {
        setCurrentIndex(currentIndex + 1);
        onNextClicked();
    };
    (0,react.useEffect)(function() {
        var addLastChild = function(children, lastChild) {
            return (0,_to_consumable_array/* default */.Z)(children).concat([
                lastChild
            ]);
        };
        if (lastChild) {
            setChildrenParsed(addLastChild(children, lastChild));
        } else {
            setChildrenParsed(children);
        }
    }, [
        lastChild,
        children
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(carousel, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: setItemsContainerRef,
                className: itemsContainer,
                style: {
                    gap: theme/* theme.spacings */.r.spacings[itemsGap]
                },
                children: childrenParsed.map(function(child, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: item,
                        style: {
                            height: "auto",
                            width: itemsWidth
                        },
                        children: child
                    }, index);
                })
            }),
            shouldLeftArrowBeVisible() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: controlContainer.left,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    "aria-label": "prev",
                    className: controlButton.left,
                    onClick: goToPrevious,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.ArrowUp */.Z.ArrowUp, {
                        style: {
                            transform: "rotate(-90deg)"
                        }
                    })
                })
            }),
            shouldRightArrowBeVisible() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: controlContainer.right,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    "aria-label": "next",
                    className: controlButton.right,
                    style: {
                        right: hasInnerNextButton ? 24 : ""
                    },
                    onClick: goToNext,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.ArrowUp */.Z.ArrowUp, {
                        style: {
                            transform: "rotate(90deg)"
                        }
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 5672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* reexport safe */ _ItemsCarousel__WEBPACK_IMPORTED_MODULE_0__.P; }
/* harmony export */ });
/* harmony import */ var _ItemsCarousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23777);



/***/ }),

/***/ 77784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ getTranslatedStateOfMaintenance; }
/* harmony export */ });
var getTranslatedStateOfMaintenance = function(stateOfMaintenance, t) {
    if (stateOfMaintenance.toLocaleLowerCase() === "fully_renovated") return t("common:renovated");
    return t("common:".concat(stateOfMaintenance.toLocaleLowerCase()));
};


/***/ }),

/***/ 43799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ getPriceStatus; },
/* harmony export */   "_": function() { return /* binding */ roundPrice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62271);


var roundPrice = function(price) {
    var priceInCents = price.cents // 30010500
    ;
    var priceInEuro = priceInCents / 100 // 300105
    ;
    var remainder = priceInEuro % 1000 // 105 if priceInEuro = 300105
    ;
    var roundedPriceInEuro = remainder < 500 ? priceInEuro - remainder : priceInEuro + (1000 - remainder // 300000
    );
    var roundedPriceInCents = roundedPriceInEuro * 100 // 30000000
    ;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, price), {
        cents: roundedPriceInCents
    });
};
var getPriceStatus = function(askedPriceCents, estimatedListingPriceCents) {
    var discountedPrice = (askedPriceCents - estimatedListingPriceCents) / askedPriceCents * 100;
    var roundedDiscountedPrice = Math.round(discountedPrice);
    var isGoodPrice = roundedDiscountedPrice < 8;
    return {
        isGoodPrice: isGoodPrice,
        roundedDiscountedPrice: roundedDiscountedPrice
    };
};


/***/ }),

/***/ 88068:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 52236:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);